<template>
    <button ref="btn"
        class="el-btn-pill"
        type="button"
        :disabled="disabled"
        @click="$emit('click', $event)">
        <i v-if="icon" :class="[icon ? `lnr-${icon}` : '']"></i>
    </button>
</template>

<script>

export default {
    name: 'mead-button-pill',
    props: {
        /**
         * Name of an icon (rendered via `lnr-{icon}`) shown inside the pill button.
         */
        icon        : {type: [String, Boolean], default: () => false},
        /**
         * Disables the button, preventing clicks and applying the disabled styling.
         */
        disabled    : {type: Boolean, default: () => false},
        /**
         * Tooltip translation key. When set, it's translated via `I18N.go` and
         * applied as the button's native `title` attribute once mounted.
         */
        title       : {type: [String, Boolean], default: () => false},
        /**
         * When true, the button automatically receives focus once mounted.
         */
        uiAutoFocus : {type: Boolean, default: () => false},
    },
    mounted () {
        //  Add title
        if (this.$refs.btn && this.title) this.$refs.btn.setAttribute('title', MeadCommon.I18N.go(this.title));

        //  UIAutoFocus
        if (this.$refs.btn && this.uiAutoFocus) this.$refs.btn.focus();
    },
};
</script>
<style lang="scss" scoped>
@import '../../../sass//_variables.scss';
@import '../../../sass/elements/forms/buttons/index';

.el-btn-pill {
    @extend %ath-button-base;
    display: inline-block;
    min-width: 3rem;
    width: 3rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: $br-m;
    flex-shrink: 0;
    position: relative;
    background-color: var(--c-brand-light-bg);
    color: var(--c-brand-light-fg);

    &:focus,
    &:hover,
    &:active {
        &:not([disabled="disabled"]) {
            background-color: var(--c-brand-default-bg);
        }
    }

    //  MODIFIERS

    &.el--transparent {
        background-color: transparent;
    }
}
</style>